import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // FontAwesome Icon


import React from 'react';
import styled from 'styled-components';
import { mergeProps } from '@arcblock/ux/lib/Util';
import { ReactComponent as BackgroundIcon } from './background.svg';
var variants = {
  light: 'fal',
  regular: 'far',
  solid: 'fas'
};

var Icon = function Icon(props) {
  var newProps = mergeProps(props, Icon, ['bg']);

  var name = newProps.name,
      color = newProps.color,
      height = newProps.height,
      fontSize = newProps.fontSize,
      variant = newProps.variant,
      bg = newProps.bg,
      rest = _objectWithoutPropertiesLoose(newProps, ["name", "color", "height", "fontSize", "variant", "bg"]);

  return /*#__PURE__*/React.createElement(Div, Object.assign({
    height: height,
    bg: bg
  }, rest), bg && /*#__PURE__*/React.createElement(BackgroundIcon, {
    className: "icon__background"
  }), /*#__PURE__*/React.createElement("div", {
    className: "icon__foreground"
  }, /*#__PURE__*/React.createElement("i", {
    className: variants[variant] + " fa-" + name + " ",
    style: {
      color: color,
      fontSize: fontSize + "px"
    }
  })));
};

Icon.defaultProps = {
  height: 45,
  variant: 'light',
  fontSize: 40,
  bg: true
};
export default Icon;
var Div = styled.div.withConfig({
  displayName: "icon__Div",
  componentId: "sc-1lker27-0"
})(["height:", "px;width:", "px;", " .icon__background{position:absolute;right:0;top:0;g{fill:rgb(78,106,246);fill-opacity:0.2;}}.icon__foreground{", "}"], function (props) {
  return props.height;
}, function (props) {
  return props.bg ? props.height * 70 / 45 : props.height;
}, function (props) {
  return props.bg ? 'position: relative;' : '';
}, function (props) {
  return props.bg ? 'position: absolute; left: 0; bottom: 0;' : '';
});